import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import RequireUser from "@/components/public/RequireUser";
import TournamentWizard from "@/components/tournament/TournamentWizard";
import CheckoutModal from "@/components/tournament/CheckoutModal";
import { useAuth } from "@/context/AuthContext";
import { useConfig } from "@/context/ConfigContext";

function Inner() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { tournament_price_usd } = useConfig();
  const [created, setCreated] = useState(null);
  const price = user.is_admin ? 0 : tournament_price_usd;
  const manage = (t) => navigate(user.is_admin ? "/admin/tournaments" : `/profile/tournaments/${t.id}`);

  return (
    <div className="mx-auto max-w-6xl px-4 md:px-6 py-10">
      <div className="eyebrow text-[hsl(var(--accent))]">Tournaments</div>
      <h1 className="text-4xl md:text-5xl font-bold text-white mt-2">Create a Tournament</h1>
      <p className="text-white/60 mt-2 mb-10">Set up your tournament in minutes. Teams join through an open registration link and QR code.</p>
      <TournamentWizard price={price} onCancel={() => navigate("/profile")}
        onCreated={(t) => { if (price > 0) setCreated(t); else { toast.success("Tournament created"); manage(t); } }} />
      {created && (
        <CheckoutModal tournament={created} price={price}
          onClose={() => { setCreated(null); manage(created); }}
          onPaid={() => { toast.success("Payment received — tournament is live!"); setTimeout(() => manage(created), 1200); }} />
      )}
    </div>
  );
}

export default function CreateTournament() {
  return <RequireUser message="Sign in with Google or email to create your tournament."><Inner /></RequireUser>;
}
